import {Component, ContentChild, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';

@Component({
  selector: 'exg-search-bar',
  templateUrl: './exg-search-bar.component.html',
  styles: []
})
export class ExgSearchBarComponent implements OnInit {

  searchValue = '';
  @ViewChild('searchInput') searchInput!: ElementRef;
  @Input() placeholder = 'Suche';
  @ContentChild('leftTemplate') leftTemplate!: TemplateRef<ElementRef>;
  @ContentChild('rightTemplate') rightTemplate!: TemplateRef<ElementRef>;
  @Output() Search: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit(): void {
  }

  setFocus(): void {
    (this.searchInput.nativeElement as HTMLElement).focus();
  }

  resetSearch(): void {
    this.searchValue = '';
    this.Search.emit(this.searchValue);
    this.setFocus();
  }

  onKeyDown(e: KeyboardEvent): void {

    if (e.key === 'Enter') {
      this.Search.emit(this.searchValue);
    }
  }


}
